import type { UscNavActionsType } from "../actions/UscNavActions";
import { USC_NAV_SET_STEP } from "../actions/UscNavActions";
import { UscNavStepEnum } from "../../utils/constants";

export type UscNavReducerType = {
    step: UscNavStepEnum;
};

export const initialStateUscNav: UscNavReducerType = {
    step: UscNavStepEnum.Pdp,
};

const UscNavReducer = (state: UscNavReducerType = initialStateUscNav, action: UscNavActionsType): UscNavReducerType => {
    switch (action.type) {
        case USC_NAV_SET_STEP: {
            const { step } = action;
            return { ...state, step };
        }

        default:
            return state;
    }
};

export default UscNavReducer;
